<template>
  <div>
    <van-nav-bar
      :title="title"
      :left-text="leftArrow ? '返回' : ''"
      :left-arrow="leftArrow"
      @click-left="more"
    />
    <van-popup
      v-model="show"
      get-container="body"
      round
      position="bottom"
      closeable
      close-icon="revoke"
      :style="{ height: '50%' }"
      :click-overlay="false"
      @close="more"
    >
      <div class="text_center pt20 pb20">返回上一步</div>
      <!-- <div class="product-list bg-white pl15 pr15">
        <product-list class="pt15 pb15" />
      </div> -->
    </van-popup>
  </div>
</template>

<script>
import { title } from "@/config";
// import productList from "@/components/productList.vue";
import { toNextPage } from "@/utils";
export default {
  name: "layHeads",
  data() {
    return {
      show: false,
      product: [],
    };
  },
  components: {
    // productList,
  },
  computed: {
    title() {
      if (
        this.$route.meta.title !== undefined &&
        this.$route.meta.title !== ""
      ) {
        return this.$route.meta.title;
      } else {
        return title;
      }
    },
    leftArrow() {
      if (
        this.$route.meta.leftArrow !== undefined &&
        this.$route.meta.leftArrow !== ""
      ) {
        return this.$route.meta.leftArrow;
      } else {
        return leftArrow;
      }
    },
  },
  beforeMount() {
    // this.$store.dispatch("common/getProduct");
  },

  methods: {
    async more() {
      // let param = {
      //   page: 1,
      // };
      // const data = await this.$store.dispatch("common/getProduct", param);
      // if (data) {
      this.$router.back();
      // }
      // this.$router.replace({name: 'home_product', query: {type: 2}})
    },
  },
};
</script>

<style lang="scss" scoped></style>
